module.exports = __webpack_public_path__ + "static/media/180817_login_willkommen_highres.7ca2f749.png";